import { HStack, Input, InputGroup, InputLeftElement } from '@chakra-ui/react';
import { FaPlus, FaSearch } from 'react-icons/fa';
import ProtectedButton from 'shared/components/ProtectedButton';
import { useResellerContext } from '../ResellerContext';

const ResellerSearchBar = () => {
  const { searchText, setSearchText, setCreateModalOpen } =
    useResellerContext();

  return (
    <HStack w="100%" gap="1rem">
      <InputGroup flex="1">
        <InputLeftElement pointerEvents="none">
          <FaSearch color="gray" />
        </InputLeftElement>
        <Input
          placeholder="Buscar por documento ou nome..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          bg="white"
        />
      </InputGroup>

      <ProtectedButton
        permission="reseller-create"
        colorScheme="yooga"
        leftIcon={<FaPlus />}
        onClick={() => setCreateModalOpen(true)}
        flexShrink={0}
      >
        Criar Cliente
      </ProtectedButton>
    </HStack>
  );
};

export default ResellerSearchBar;
